import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const POST_MANUAL_AML_REQUEST = 'POST_MANUAL_AML_REQUEST'
export const POST_MANUAL_AML_SUCCESS = 'POST_MANUAL_AML_SUCCESS'
export const POST_MANUAL_AML_FAILURE = 'POST_MANUAL_AML_FAILURE'

export const manualAml = (body) => ({
  [CALL_API]: {
    endpoint: '/api/single-aml/',
    types: [POST_MANUAL_AML_REQUEST, POST_MANUAL_AML_SUCCESS, POST_MANUAL_AML_FAILURE],
    method: 'POST',
    tokenType: API_JWT_TOKEN_NAME,
    body,
  },
})
